import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormRecord } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdsCampaign } from 'src/app/classes/ads-campaign';
import { AdsCampaignAsset } from 'src/app/classes/ads-campaign-asset';
import { AdsCampaignAssetService } from 'src/app/services/ads-campaign-asset.service';
import Languages from 'src/app/constants/languages';
import * as fa from '@fortawesome/free-solid-svg-icons';
import adsCampaignAssetPlacements from 'src/app/constants/ads-campaign-asset-placements';

const CONTENT_MIN_LENGTH = 3
const CONTENT_MAX_LENGTH = 255

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.css']
})

export class AssetComponent implements OnInit {
  adsCampaign: AdsCampaign
  adsCampaignAsset: AdsCampaignAsset | undefined

  fa = fa
  languages = Languages
  adsCampaignAssetPlacements = adsCampaignAssetPlacements
  customerPlacements: string[] = []
  employeePlacements: string[] = []

  translations: string[] = []
  previewLanguage: string | null = null

  yourContent = $localize`Your content will appear here`;

  uploadFile: File | null = null;

  form = new FormRecord<FormControl<string>|FormControl<number>|FormControl<boolean>>({
    content: new FormControl('', [Validators.required, Validators.maxLength(CONTENT_MAX_LENGTH), Validators.minLength(CONTENT_MIN_LENGTH)]),
    url: new FormControl('', [Validators.required, Validators.pattern('^https?://.*$')]),
    bid: new FormControl(0, [Validators.required, Validators.min(0)]),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private adsCampaignAssetService: AdsCampaignAssetService
  ) { }

  ngOnInit(): void {
    for (let lang of this.adsCampaign.organization.languages.split(',')) {
      this.form.addControl(`content_${lang}`, new FormControl('', [Validators.maxLength(CONTENT_MAX_LENGTH), Validators.minLength(CONTENT_MIN_LENGTH)]));
      this.form.addControl(`url_${lang}`, new FormControl('', [Validators.pattern('^https?://.*$')]));
    }

    for (let placement of Object.keys(adsCampaignAssetPlacements)) {
      this.form.addControl(`${placement}`, new FormControl(false, [Validators.required]));

      if(placement.startsWith('customer_')) {
        this.customerPlacements.push(placement);
      } else if(placement.startsWith('employee_')) {
        this.employeePlacements.push(placement);
      }
    }

    this.form.updateValueAndValidity();

    this.translations = this.adsCampaign.organization.languages.split(',')

    if (this.adsCampaignAsset.id) {
      this.adsCampaignAssetService.get(this.adsCampaign.id, this.adsCampaignAsset.id).subscribe(adsCampaignAsset => {
        this.adsCampaignAsset = adsCampaignAsset;
        this.form.patchValue(adsCampaignAsset);
      });
    }
    else {
      this.adsCampaignAsset = new AdsCampaignAsset();
      this.adsCampaignAsset.picture = this.adsCampaign.ads_organization.picture
    }
  }

  save(): void {
    this.adsCampaignAssetService.save(this.adsCampaign.id, this.adsCampaignAsset?.id, {
      ...this.form.value,
      picture: this.uploadFile as unknown as string
    } as AdsCampaignAsset)
      .subscribe(() => {
        this.activeModal.close();
      });
  }

  delete(): void {
    this.adsCampaignAssetService.delete(this.adsCampaign.id, this.adsCampaignAsset.id).subscribe(() => {
      this.activeModal.close();
    });
  }

  translate() {

  }

  clickPreview() {
    const url = ((this.form.controls['url' + (this.previewLanguage || '')].value) || this.form.controls['url'].value) as string

    if (!url) {
      alert($localize`Please enter a valid URL`);
      return;
    }

    window.open(url, '_blank');
  }

  // Take the local file and Base64 encode it to adsCampaignAsset.picture
  imageUpdate(event: any) {
    const file: File = event.target.files[0]

    this.uploadFile = file;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.adsCampaignAsset.picture = reader.result as string;
      }
      reader.readAsDataURL(file);
    }
  }

  selectAllPlacements() {
    for (let placement of this.customerPlacements.concat(this.employeePlacements)) {
      (this.form.controls[placement] as FormControl).setValue(true);
    }
  }
}
